export default function AmbientePark(){
    return(
        <div className="ambienteParkImg">
        </div>
    )
}